import React from 'react';
import { Content, ContentType } from '@amzn/awscat-pattern-library-service-model';
import {
  convertCodeRepository,
  convertContentMetadata,
  convertContentTypeMetadata,
  convertTemplateMetadata,
  getContentPages,
} from '../../utils/ConverterUtils';
import JSONSerializer from '../../../common/JSONSerializer';
import ContentConverterInput from './ContentConverterInput';
import { DefaultContentSubTypeMap } from '../../utils/SelectableOptions';
import { localLog } from '../../../loggers/Logger';
import { autoGenerateHref } from '../../../api/ContentUtil';

interface Props {
  content: Content;
  onDismiss?: () => void;
  onError: (errorMsg?: string) => void;
  onSuccess: (updatedContent: Content) => void;
  toContentType: ContentType;
}

const DefaultConverter: React.FunctionComponent<Props> = (props: Props) => {
  const {
    content,
    content: {
      contentMetadata: { contentType },
    },
    onDismiss,
    onError,
    onSuccess,
    toContentType,
  } = props;
  const contentSubType = DefaultContentSubTypeMap.get(toContentType);
  const contentPages = getContentPages(content);

  const convertContent = (updatedContent: Content) => {
    const { contentData, contentTypeMetadata, contentMetadata } = updatedContent;
    // @ts-expect-error TS2345 - strict migration
    convertContentTypeMetadata(contentTypeMetadata, contentSubType);
    convertContentMetadata(contentMetadata, toContentType);
    // @ts-expect-error TS2345 - strict migration
    convertTemplateMetadata(content, contentSubType);
    convertCodeRepository(updatedContent, toContentType);
    autoGenerateHref(contentData, contentMetadata, true);
  };

  const convertDefault = () => {
    const serializer: JSONSerializer = new JSONSerializer();
    const updatedContent = serializer.deserialize<Content>(serializer.stringify(content), Content);
    convertContent(updatedContent);
    onSuccess(updatedContent);
  };

  const onConfirm = () => {
    try {
      convertDefault();
    } catch (err) {
      localLog.error(err);
      // @ts-expect-error TS18046 - strict migration
      onError(err.message);
    }
  };

  return (
    <ContentConverterInput
      fromSections={contentPages}
      fromContentType={contentType}
      toContentType={toContentType}
      onConfirm={onConfirm}
      onCancel={onDismiss}
    />
  );
};

export default DefaultConverter;
